import styles from './Footer.module.css'

export default function Footer() {
  return (
    <footer className={styles.footer}>
      © 2026 ACCIONA — Requirements Platform {' '}
    </footer>
  )
}
